import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppDatashareservice {

  private contentDataPassSource = new BehaviorSubject('default message');
  currentData = this.contentDataPassSource.asObservable();

  constructor() { }

  changeData(message: string) {
    this.contentDataPassSource.next(message);
  }

}
